import { PRIMARY_COLOR } from "../../../styles/colors";

const SpeakerIcon = ({ color = PRIMARY_COLOR }: any) => (
  <svg
    width={41}
    height={42}
    viewBox={`0 0 ${41} ${42}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={32} height={32} rx="10" fill={color} fillOpacity="0.16" />
    <path
      d="M27 19.9375V35.3875C26.9996 35.572 27.0509 35.753 27.1481 35.9099C27.2453 36.0668 27.3846 36.1932 27.55 36.275L29.8875 37.4375C30.0207 37.506 30.1678 37.5434 30.3176 37.5466C30.4674 37.5499 30.6159 37.5191 30.752 37.4564C30.8881 37.3938 31.0082 37.301 31.1031 37.1851C31.1981 37.0692 31.2654 36.9333 31.3 36.7875L33 30"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 30C34.3261 30 35.5979 29.4733 36.5355 28.5356C37.4732 27.5979 38 26.3261 38 25C38 23.674 37.4732 22.4022 36.5355 21.4645C35.5979 20.5268 34.3261 20 33 20H28C28 20 21.1875 20 14.6375 14.5125C14.4918 14.392 14.3149 14.3152 14.1274 14.2911C13.9398 14.267 13.7493 14.2966 13.5778 14.3764C13.4064 14.4562 13.2611 14.583 13.1589 14.7421C13.0566 14.9011 13.0015 15.0859 13 15.275V34.725C13.0015 34.9141 13.0566 35.0989 13.1589 35.258C13.2611 35.417 13.4064 35.5438 13.5778 35.6236C13.7493 35.7035 13.9398 35.7331 14.1274 35.709C14.3149 35.6849 14.4918 35.6081 14.6375 35.4875C21.1875 30 28 30 28 30H33Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SpeakerIcon;
